<div class="custom-modal">
    <div class="header">
        <h1 mat-dialog-title>
            Agentes
        </h1>
        <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
        <mat-card-content class="no-padding">
            <div>
                <form class="filtros-header" [formGroup]="stateForm">
                    <div class="header-filter-log">
                        <mat-form-field class="example-full-width">
                            <mat-label>Código IATA</mat-label>
                            <input matInput type="text" formControlName="agente">
                        </mat-form-field>

                        <mat-form-field class="example-full-width">
                            <mat-label>Nome Fantasia</mat-label>
                            <input matInput type="text" formControlName="nomeFantasia">
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>UF</mat-label>
                            <mat-select formControlName="uf">
                                <mat-option *ngFor="let item of ufs" [value]="item?.nome">{{ item?.nome }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <button mat-icon-button class="notification-button  float-right cursor-pointer-icon" (click)="search()"
                            matTooltip="Pesquisar">
                            <mat-icon fontSet="fas" fontIcon="fa-search"></mat-icon>
                        </button>
                    </div>
                </form>
            </div>
            <div>
                <table id="relatorios" mat-table [dataSource]="agentCollection" class="table-sm">
                    <ng-container matColumnDef="checkbox">
                        <th mat-header-cell *matHeaderCellDef class="text-center" class="checkbox" scope="col">
                            <mat-checkbox color="primary" #allCheckbox *ngIf="agentCollection.data && agentCollection.data.length"
                                (change)="selectAll($event.checked)" [checked]="allSelected"
                                [indeterminate]="someSelected"></mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let item" class="text-center" class="checkbox">
                            <mat-checkbox color="primary" *ngIf="agentCollection.data && agentCollection.data.length"
                                (change)="select(item, $event.checked)" [checked]="item.selected">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="agente">
                        <th mat-header-cell *matHeaderCellDef class="text-center">Código IATA</th>
                        <td mat-cell *matCellDef="let item" class="text-center">
                            {{ item.nome }}</td>
                    </ng-container>

                    <ng-container matColumnDef="nomeFantasia">
                        <th mat-header-cell *matHeaderCellDef class="text-center">Nome Fantasia</th>
                        <td mat-cell *matCellDef="let item" class="text-center">
                            {{ item.nomeFantasia }}</td>
                    </ng-container>

                    <ng-container matColumnDef="uf">
                        <th mat-header-cell *matHeaderCellDef class="text-center">UF</th>
                        <td mat-cell *matCellDef="let item" class="text-center">
                            {{ item.uf }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div *ngIf="!isLoading && agentCollection?.data?.length === 0"
                    class="d-flex justify-content-center align-items-center" style="height: 100px;">
                    Nenhum registro foi encontrado!
                </div>
                <mat-paginator [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
                    (page)="onPageChange($event)" [pageSizeOptions]="[5, 10, 15]"></mat-paginator>
            </div>

        </mat-card-content>
        <mat-divider></mat-divider>
        <div>
        </div>
    </div>
    <div class="modal-actions" mat-dialog-actions align="end">
        <button mat-flat-button mat-dialog-close color="primary" (click)="apply()">Aplicar</button>
    </div>
</div>